"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpersonationModule = exports.ImpersonationTrigger = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../util/colors");
var grid_1 = require("../components/grid");
var Link_1 = require("../components/Link");
var spacing_1 = require("../components/spacing");
var typography_1 = require("../components/typography");
var api_1 = require("../util/api");
var hooks_1 = require("../util/hooks");
var ImpersonationTrigger = function () {
    var query = new URLSearchParams(window.location.search);
    var impersonateId = query.get('impersonate_id');
    (0, react_1.useEffect)(function () {
        if (!impersonateId)
            return;
        (0, api_1.impersonate)(impersonateId, { storage: 'session' });
        window.location.replace(window.location.origin);
    }, [impersonateId]);
    return null;
};
exports.ImpersonationTrigger = ImpersonationTrigger;
var Footer = styled_components_1.default.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: ", ";\n  z-index: 1000000;\n"], ["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: ", ";\n  z-index: 1000000;\n"])), colors_1.colors.red600);
var ImpersonationModule = function (_a) {
    var userName = _a.userName, apiBase = _a.apiBase;
    var _b = (0, react_1.useState)(false), hidden = _b[0], setHidden = _b[1];
    var isNarrow = (0, hooks_1.useBreakpoint)('sm');
    if (hidden || !(0, api_1.isImpersonating)())
        return null;
    var stop = function () {
        (0, api_1.stopImpersonating)(apiBase);
        window.location.replace(window.location.origin);
    };
    return (react_1.default.createElement(Footer, null,
        react_1.default.createElement(grid_1.Container, { align: "center", justify: "space-between", px: 3, py: 1 },
            react_1.default.createElement(grid_1.Item, { cols: isNarrow ? 12 : 6, pb: isNarrow ? 2 : 0, align: "center", justify: isNarrow ? 'center' : 'flex-start' },
                react_1.default.createElement(typography_1.P, { weight: 700, color: colors_1.colors.white },
                    "You are impersonating ",
                    userName)),
            react_1.default.createElement(grid_1.Item, { cols: isNarrow ? 12 : 6, align: "center", justify: isNarrow ? 'center' : 'flex-end' },
                react_1.default.createElement(spacing_1.Div, { pr: 3 },
                    react_1.default.createElement(Link_1.Link, { underline: true, color: colors_1.colors.white, onClick: stop }, "Stop impersonating")),
                react_1.default.createElement(Link_1.Link, { underline: true, color: colors_1.colors.white, onClick: function () { return setHidden(true); } }, "Hide me")))));
};
exports.ImpersonationModule = ImpersonationModule;
var templateObject_1;
//# sourceMappingURL=impersonation.js.map